// Nomes onde a raiz do dominio tem tres partes: empresa.com.br e raiz, e nao
// um subdominio de com.br. Sem isso o painel pediria o registro no lugar errado.
const SUFIXOS_COMPOSTOS = new Set([
  'com.br', 'net.br', 'org.br', 'adv.br', 'app.br', 'art.br', 'blog.br', 'dev.br',
  'eco.br', 'eng.br', 'esp.br', 'ind.br', 'inf.br', 'med.br', 'psi.br', 'rec.br',
  'srv.br', 'tur.br', 'tv.br', 'vet.br', 'agr.br', 'etc.br', 'emp.br', 'far.br',
  'co.uk', 'org.uk', 'me.uk', 'com.pt', 'com.ar', 'com.mx', 'com.co', 'com.py',
  'com.uy', 'co.jp', 'com.au', 'net.au', 'org.au', 'com.es', 'co.za',
]);

function partesDoDominio(dominio) {
  const limpo = String(dominio || '')
    .replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();
  const partes = limpo.split('.').filter(Boolean);
  const tamanhoRaiz = SUFIXOS_COMPOSTOS.has(partes.slice(-2).join('.')) ? 3 : 2;
  return { partes, tamanhoRaiz };
}

// No painel DNS, o campo "Nome" e "@" so quando o dominio e a raiz. Para um
// subdominio (loja.empresa.com.br) o registro tem que ser criado em "loja".
export function getNomeRegistroDns(dominio) {
  const { partes, tamanhoRaiz } = partesDoDominio(dominio);
  if (partes.length <= tamanhoRaiz) return '@';
  return partes.slice(0, partes.length - tamanhoRaiz).join('.');
}

// A zona onde o registro precisa ser criado: para loja.empresa.com.br e
// empresa.com.br, que e onde o cliente encontra o DNS no provedor dele.
export function getDominioRaiz(dominio) {
  const { partes, tamanhoRaiz } = partesDoDominio(dominio);
  return partes.slice(-tamanhoRaiz).join('.');
}

export function getCustomDomain(site) {
  if (site.customDomain) return `https://${site.customDomain}`;
  if (site.url) return site.url;
  if (site.name) return `https://${site.name}.ftmpainel.com.br`;
  return '#';
}

export function getDisplayDomain(site) {
  if (site.customDomain) return site.customDomain;
  if (site.url) return site.url.replace(/^https?:\/\//, '');
  if (site.name) return `${site.name}.ftmpainel.com.br`;
  return '-';
}

export function openSite(site) {
  const url = getCustomDomain(site);
  if (url && url !== '#') {
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
  }
  return false;
}
